module.exports = __webpack_public_path__ + "5805aadc4cb65477c90f07788bc2ae31.GIF";